import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrelloService {

	private baseUrl = 'https://api.trello.com/1';
	public apiKey = '11a11c6bf092423a923bb99687b1befd';
	public apiToken = 'ATTA1922c76f21f5c8c5d49b7545801e7943fb102e85b382f7c75debb03f35fde2da109EB053';

	mainBoardId = '67505cd5dc84a733a10157ad';

	constructor(private http: HttpClient) {  }

	getChecklistProgress(checklistItems: { idCheckItem: string; state: string }[]): string {
		const completedItems = checklistItems.filter(item => item.state === 'complete').length;
		const totalItems = checklistItems.length;
		return `${completedItems}/${totalItems}`;
	}

	getBoard(boardId: string): Observable<any> {
		const url = `${this.baseUrl}/boards/${boardId}`;
		return this.http.get(url, {
			params: {
				key: this.apiKey,
				token: this.apiToken,
			},
		});
	}

	getLists(boardId: string): Observable<any> {
		const url = `${this.baseUrl}/boards/${boardId}/lists`;
		return this.http.get(url, {
			params: {
				key: this.apiKey,
				token: this.apiToken,
			},
		});
	}

	getCards(listId: string): Observable<any> {
		const url = `${this.baseUrl}/lists/${listId}/cards`;
		return this.http.get(url, {
			params: {
				key: this.apiKey,
				token: this.apiToken,
			},
		});
	}

	getCardComments(cardId: string): Observable<any> {
		const url = `${this.baseUrl}/cards/${cardId}/actions`;
		return this.http.get(url, {
			params: {
				key: this.apiKey,
				token: this.apiToken,
				filter: 'commentCard',
			},
		});
	}

	getBoardActions(boardId: string, limit: number = 100): Observable<any> {
		const url = `${this.baseUrl}/boards/${boardId}/actions`;
		return this.http.get(url, {
			params: {
				key: this.apiKey,
				token: this.apiToken,
				limit: limit.toString(), // Limita o número de ações
			},
		});
	}

	createCard(name: string, desc: string = ''): Observable<any> {
		const url = `${this.baseUrl}/cards`;
		const body = {
		  	idList: '67760736ce8a36f6dc72b66a',
			name: 'New request from ' + name,
			desc,
			pos: 'bottom',
			key: this.apiKey,
			token: this.apiToken,
		};
		return this.http.post(url, body);
	}

	getChecklistById(checklistId: string): Observable<any> {
		const url = `${this.baseUrl}/checklists/${checklistId}`;
		return this.http.get(url, {
			params: {
				key: this.apiKey,
				token: this.apiToken,
			},
		});
	}


}
